<template>
  <el-dialog v-model="dialogVisible" width="440px" modal-class="login-modal">
    <!-- :close-on-click-modal="false"
    :show-close="false" -->
    <Login ref="loginRef" :isDialog="true" @login="closeDialog" />
  </el-dialog>
</template>
<script setup>
import { ref, defineExpose, inject } from "vue";
import Login from "./Login.vue";

const dialogVisible = ref(false);
const loginRef = ref(null);
/**打开弹框 */
const openDialog = () => {
  dialogVisible.value = true;
  loginRef.value.init();
};
const closeDialog = () => {
  dialogVisible.value = false;
  setTimeout(() => {
    window.location.reload();
  }, 500);
};

/**暴露属性及方法 */
defineExpose({
  openDialog,
  closeDialog,
});
</script>

<style scoped lang="scss"></style>
